export enum ReportType {
  vehicleActivityReport = 1,
  vehiclePoiVisitsByDate = 2,
  vehicleMovement = 3,
  vehicleExceptions = 4,
  fbtLogbook = 5,
  rawDataExtract = 6,
  completeVehicleListing = 7,
  vehicleDriverLogbook = 8
}
